export default __webpack_public_path__ + "static/media/photo--lg--reception.8e7a0511.jpg";